import React, { Component } from 'react';
import { connect } from 'react-redux';
import { openStripeBuyProductModal, requestOrderInvoice } from '../../../../store/actions/paymentActions';

class RequestOrderInvoice extends Component {

    componentDidMount() {
        this.props.openStripeBuyProductModal();
    }

    handleRequest = () => {
        console.log("GET INVOICE", this.props.orderId);
        const { coid } = this.props.companyData;
        this.props.requestOrderInvoice(this.props.orderId, coid);
    }

    render() {
        const { orderId, modalInfoTextStyle, payment } = this.props;
        const { isBuyProdActed, isBuyProdActing, buyProdActMessage } = payment;
        const relevantButton = !isBuyProdActed ? !isBuyProdActing ? <button className="btn btn-dark btn-sm" onClick={this.handleRequest} disabled={isBuyProdActing}>Send me this invoice</button> : <button className="btn btn-dark btn-sm" type="button" disabled>
            <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
            &nbsp; Generating and sending invoice...
        </button> : <React.Fragment />

        const relevantMessage = !isBuyProdActed ? !isBuyProdActing ? `You will be emailed and/or notified by AssetTag with the invoice for order id: ${orderId}` : "Processing..." : buyProdActMessage

        return (
            <div>
                <p style={modalInfoTextStyle}>{relevantMessage}</p>
                {/* <button className="btn btn-danger btn-sm" onClick={this.handleRequest}>Unsubscribe to this product now</button> */}
                <br/>
                {relevantButton}
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        themeColors: state.theme,

        formLabelStyle: state.appControl.formLabelStyle,
        modalStyles: state.appControl.modalStyles,
        modalWidth: state.appControl.modalWidthMedium,
        modalTitleStyle: state.appControl.modalTitleStyle,
        modalInfoTextStyle: state.appControl.modalInfoTextStyle,

        userData: state.firebase.profile,
        userId: state.firebase.auth.uid,
        companyData: state.firestore.data.Company,

        payment: state.payment,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        requestOrderInvoice: (orderId, coid) => dispatch(requestOrderInvoice(orderId, coid)),
        openStripeBuyProductModal: () => dispatch(openStripeBuyProductModal()),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(RequestOrderInvoice);